<bb-display-order *ngIf="!!order"
                  [order]="order"
                  [allowGrid]="true"
                  (openItemSummary)="openEditOrderItemSummary($event)"
                  (removeItemSummary)="removeItemSummary($event)"
                  (addToSummary)="addItem($event)"
                  (removeFromSummary)="removeItem($event)">
</bb-display-order>
